export default "__VITE_ASSET__c55705e1__"